import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type ReferralAttrs = FancyOk<fancyOperations['getReferralsR']>[0]

export const fetchReferrals = (): Promise<Array<ReferralAttrs>> =>
  fancyClient.GET('/2/referrals').then(extractData)
